var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.875V12.8838M8.5 9.81251C8.48389 9.52846 8.56051 9.24687 8.71833 9.01015C8.87614 8.77342 9.1066 8.59439 9.375 8.50001C9.70389 8.37424 9.99909 8.17384 10.2374 7.9146C10.4757 7.65535 10.6505 7.34433 10.7482 7.00603C10.8458 6.66772 10.8636 6.31137 10.8001 5.96502C10.7367 5.61867 10.5937 5.29178 10.3824 5.01009C10.1711 4.72839 9.89736 4.49959 9.58263 4.34168C9.26791 4.18377 8.92083 4.10107 8.56871 4.10009C8.21659 4.09912 7.86906 4.17989 7.55346 4.33605C7.23787 4.49221 6.96283 4.71949 6.75 5.00001M0.625 8.5C0.625 9.53416 0.828693 10.5582 1.22445 11.5136C1.6202 12.4691 2.20027 13.3372 2.93153 14.0685C3.6628 14.7997 4.53093 15.3798 5.48637 15.7756C6.44181 16.1713 7.46584 16.375 8.5 16.375C9.53416 16.375 10.5582 16.1713 11.5136 15.7756C12.4691 15.3798 13.3372 14.7997 14.0685 14.0685C14.7997 13.3372 15.3798 12.4691 15.7756 11.5136C16.1713 10.5582 16.375 9.53416 16.375 8.5C16.375 7.46584 16.1713 6.44181 15.7756 5.48637C15.3798 4.53093 14.7997 3.6628 14.0685 2.93153C13.3372 2.20027 12.4691 1.6202 11.5136 1.22445C10.5582 0.828693 9.53416 0.625 8.5 0.625C7.46584 0.625 6.44181 0.828693 5.48637 1.22445C4.53093 1.6202 3.6628 2.20027 2.93153 2.93153C2.20027 3.6628 1.6202 4.53093 1.22445 5.48637C0.828693 6.44181 0.625 7.46584 0.625 8.5Z",
    stroke: "#2D1C5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.eaf21ebf3589e82173cd9eec2470c415.svg";
export { ForwardRef as ReactComponent };